import { Pipe, PipeTransform } from '@angular/core';
import { findByProp } from '../../../utils';

@Pipe({
    name: 'koltseghelyPipe'
})

export class KoltseghelyPipe implements PipeTransform {
    transform(koltseghely_id: any, koltseghelyek: any[]): any {
        console.log('koltseghelypipe', koltseghelyek)
        return findByProp(koltseghelyek, 'id', koltseghely_id)?.megnevezes || '-';
    }
}